import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tx_loading = _resolveComponent("tx-loading")!
  const _component_create_red_pack = _resolveComponent("create-red-pack")!
  const _component_bg_slot = _resolveComponent("bg-slot")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, null, {
    other: _withCtx(() => [
      _createVNode(_component_bg_slot, null, {
        default: _withCtx(() => [
          (_ctx.pageReady)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.txLoading)
                  ? (_openBlock(), _createBlock(_component_tx_loading, {
                      key: 0,
                      title: _ctx.redpackInfo.title,
                      from: _ctx.account.show,
                      chainId: _ctx.chainId,
                      tokenName: _ctx.tokenInfoInit.symbol
                    }, null, 8, ["title", "from", "chainId", "tokenName"]))
                  : (_openBlock(), _createBlock(_component_create_red_pack, {
                      key: 1,
                      ref: "createRedPackRef",
                      address: _ctx.account.show,
                      balance: _ctx.balance,
                      tokenInfo: _ctx.tokenInfoInit,
                      chainId: _ctx.chainId,
                      provider: _ctx.provider,
                      sendLoading: _ctx.sendLoading,
                      redPackContractAddr: _ctx.redpackContract.contract.address,
                      onSendRedPack: _ctx.createRedPackHandler
                    }, null, 8, ["address", "balance", "tokenInfo", "chainId", "provider", "sendLoading", "redPackContractAddr", "onSendRedPack"]))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}